module.exports = __webpack_public_path__ + "img/forward.e257a03f.svg";